// Generated by purs version 0.15.16
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Widgets_Form from "../Widgets.Form/index.js";
import * as Widgets_Form_Access from "../Widgets.Form.Access/index.js";
var any = /* #__PURE__ */ Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var EditablePrivileged = /* #__PURE__ */ (function () {
    function EditablePrivileged() {

    };
    EditablePrivileged.value = new EditablePrivileged();
    return EditablePrivileged;
})();
var EditableUnprivileged = /* #__PURE__ */ (function () {
    function EditableUnprivileged() {

    };
    EditableUnprivileged.value = new EditableUnprivileged();
    return EditableUnprivileged;
})();
var UneditablePrivileged = /* #__PURE__ */ (function () {
    function UneditablePrivileged() {

    };
    UneditablePrivileged.value = new UneditablePrivileged();
    return UneditablePrivileged;
})();
var UneditableUnprivileged = /* #__PURE__ */ (function () {
    function UneditableUnprivileged() {

    };
    UneditableUnprivileged.value = new UneditableUnprivileged();
    return UneditableUnprivileged;
})();
var step3Editability = function (canLock) {
    return function (lockedAt) {
        return function (form) {
            var isMutableField = function (path) {
                return Widgets_Form_Access.canUpdate(Widgets_Form_Access.resolveFieldAccess(form.access)(path));
            };
            var hasEditableFields = any(isMutableField)(Widgets_Form.formFieldPaths(form));
            var lockedBanner = (function () {
                if (lockedAt instanceof Data_Maybe.Nothing) {
                    return Data_Maybe.Nothing.value;
                };
                if (lockedAt instanceof Data_Maybe.Just) {
                    return new Data_Maybe.Just((function () {
                        if (canLock) {
                            if (hasEditableFields) {
                                return EditablePrivileged.value;
                            };
                            return UneditablePrivileged.value;
                        };
                        if (hasEditableFields) {
                            return EditableUnprivileged.value;
                        };
                        return UneditableUnprivileged.value;
                    })());
                };
                throw new Error("Failed pattern match at Steps.Step3.Editability (line 33, column 20 - line 42, column 44): " + [ lockedAt.constructor.name ]);
            })();
            return {
                hasEditableFields: hasEditableFields,
                lockedBanner: lockedBanner
            };
        };
    };
};
var eqLockedBanner = {
    eq: function (x) {
        return function (y) {
            if (x instanceof EditablePrivileged && y instanceof EditablePrivileged) {
                return true;
            };
            if (x instanceof EditableUnprivileged && y instanceof EditableUnprivileged) {
                return true;
            };
            if (x instanceof UneditablePrivileged && y instanceof UneditablePrivileged) {
                return true;
            };
            if (x instanceof UneditableUnprivileged && y instanceof UneditableUnprivileged) {
                return true;
            };
            return false;
        };
    }
};
var ordLockedBanner = {
    compare: function (x) {
        return function (y) {
            if (x instanceof EditablePrivileged && y instanceof EditablePrivileged) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof EditablePrivileged) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof EditablePrivileged) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof EditableUnprivileged && y instanceof EditableUnprivileged) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof EditableUnprivileged) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof EditableUnprivileged) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof UneditablePrivileged && y instanceof UneditablePrivileged) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof UneditablePrivileged) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof UneditablePrivileged) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof UneditableUnprivileged && y instanceof UneditableUnprivileged) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Steps.Step3.Editability (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqLockedBanner;
    }
};
export {
    EditablePrivileged,
    EditableUnprivileged,
    UneditablePrivileged,
    UneditableUnprivileged,
    step3Editability,
    eqLockedBanner,
    ordLockedBanner
};
//# sourceMappingURL=index.js.map
